import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import { Container, Col } from 'react-bootstrap';
import PostsPage from '../../../modules/post/PostsPage';

const Posts = () => {
  const breadcrumbItems = [
    { label: '', link: '/', icon: 'fa-solid fa-house' },
    { label: 'Posts', link: '/post', active: true },
  ];

  return (
    <>
      <div className="bread-crumb">
        <Container>
          <Col md={8}>
            <BreadCrumb items={breadcrumbItems} />
          </Col>
        </Container>
      </div>

      <PostsPage routeBase="/post" />
    </>
  );
};

export default Posts;